import General from "./General";

export default class Navigation {
  static getCartUrl(){
    const cartPageSlug = window.CURRENT_WEBSITE.cart_page_slug || 'shop/cart'
    return Navigation.getUrl(`/${cartPageSlug}`);
  }

  static getProductUrl(productId, selectedVariant){
    const productPageSlug = window.CURRENT_WEBSITE.product_page_slug || 'shop/product'
    return Navigation.getUrl(`/${productPageSlug}/${productId}${selectedVariant ? `?variant=${selectedVariant.variantDetailId}` : ""}`);
  }

  static getCollectionUrl(collectionId){
    const collectionPageSlug = window.CURRENT_WEBSITE.collection_page_slug || 'shop/collection'
    return Navigation.getUrl(`/${collectionPageSlug}/${collectionId}`);
  }

  static getUrl(url, ccPageId=null) {
    if(ccPageId && window.pageData?.funnelData?.pages) {
      const matchingPage = window.pageData?.funnelData?.pages.find(page =>
        page.pageView.length > 0 && page.pageView[0].referenceId == ccPageId
      )
      if(matchingPage && matchingPage.urlSlug){
        url = matchingPage.urlSlug
      }
    }
    if(!url?.startsWith("http")){
      let join = url.startsWith("/") ? "" : "/"
      url = General.getBaseUrl() + join + url
    }
    if(window.WEBSITE_VERSION_ID){
      const join = url.indexOf("?") === -1 ? "?" : "&"
      url += join + "v=" + window.WEBSITE_VERSION_ID
    }
    return url
  }
}
